import { Channel, CHANNELS, SEGMENT_PATHS } from '@sparknz/journeys-common';

import { BUSINESS_PATH } from 'shared/constants/paths.constants';

export const getAEMPath = (route: string, isBusiness: boolean) =>
  `/online${isBusiness ? BUSINESS_PATH : ''}${route}`;

export const getPath = (route: string, channel: Channel) => {
  switch (channel) {
    case CHANNELS.SPARK_DIGITAL_SHOP:
      return `${SEGMENT_PATHS.LARGE_BUSINESS_AND_GOVERNMENT}${route}`;
    case CHANNELS.BUSINESS_SHOP:
      return `${SEGMENT_PATHS.BUSINESS}${route}`;
    default:
      return route;
  }
};
